(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('practitioner', {
            parent: 'entity',
            url: '/practitioner?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practitioner.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practitioner/practitioners.html',
                    controller: 'PractitionerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practitioner');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('practice');
                    $translatePartialLoader.addPart('professionalCategory');
                    $translatePartialLoader.addPart('treatmentType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('practitioner-detail', {
            parent: 'practitioner',
            url: '/practitioner/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practitioner.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practitioner/practitioner-detail.html',
                    controller: 'PractitionerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practitioner');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('professionalCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Practitioner', function($stateParams, Practitioner) {
                    return Practitioner.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'practitioner',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('practitioner-detail.edit', {
            parent: 'practitioner-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practitioner.new', {
            parent: 'practitioner',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                salutation: null,
                                firstname: null,
                                lastname: null,
                                phone: null,
                                addressStreet: null,
                                addressStreetNumber: null,
                                addressCity: null,
                                addressPostalCode: null,
                                profession: null,
                                professionalCategory: null,
                                email: null,
                                pictureUrl: null,
                                taxpunktwert: null,
                                externalCalendarId: null,
                                externalCalendarData: null,
                                bookingPictureUrl: null,
                                cvUrl: null,
                                customProfession: null,
                                sortingOrder: null,
                                hideOnProfile: null,
                                titleText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('practitioner');
                });
            }]
        })
        .state('practitioner.edit', {
            parent: 'practitioner',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practitioner.delete', {
            parent: 'practitioner',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-delete-dialog.html',
                    controller: 'PractitionerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
